import React, {useContext} from 'react';
import {LanguageContext} from '../../contexts/LanguageContext'
import { GiHamburgerMenu } from 'react-icons/gi'
import {MdOutlineRestaurantMenu } from 'react-icons/md'
import {motion} from 'framer-motion'

// import images from '../../constants/images'

import './Navbar.css';

const Navbar = () => {

  const {language,updateLanguage } = useContext(LanguageContext)
  // const [actualLanguage, setActualLangiage] = useState(language)
  const [toggleMenu, setToggleMenu] = React.useState(false)

  const list = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  }
  
  const item = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -100 },
  }
  
  
  return (
  <nav className='app__navbar'>
    <div className='app__navbar-logo'>
      {/* <img src={images.gericht} alt="app logo" /> */}
      <a href='/'>
        <div style={{color:"#894e3f", fontSize:'27px', fontWeight:'700', lineHeight:'29.9px', fontFamily:'Cormorant Upright'}}>
          DOLCI PARADISE
        </div>
      </a>

    </div>
    <motion.ul className="app__navbar-links" initial="hidden" animate="visible" variants={list}>
      <motion.li className="p__opensans" variants={item}><a href="/">Home</a></motion.li>
      <motion.li className="p__opensans" variants={item}><a href="/about">About</a></motion.li>
      <motion.li className="p__opensans" variants={item}><a href="/menu">Menu</a></motion.li>
      <motion.li className="p__opensans" variants={item}><a href="/gallery">Gallery</a></motion.li>
      <motion.li className="p__opensans" variants={item}><a href="#contact">Contact</a></motion.li>
    </motion.ul>
    
    <div className="app__navbar-login" >
      {/* <a href="#login" className="p__opensans">Log In / Register</a> */}
        {/* <label style={{marginRight:'4px' }} className='p__opensans' htmlFor="language">Language: </label> */}

        <select onChange={(event) => updateLanguage(event.target.value) } defaultValue={language} className='app__navbar-select' name="language" id="cars">
          <option value="EN" >{language==="ES"?"Inglés":"English"}</option>
          <option value="ES" >{language==="ES"?"Español":"Spanish"}</option>
        </select>
    {/* <div />
      <a href="/" className="p__opensans" >Book Table</a> */}
    </div>

    {/* Menu for mobile devices */}
    <div className="app__navbar-smallscreen">
      <GiHamburgerMenu color="#c37960" fontSize={27} onClick={() => setToggleMenu(true)} />
      
      {toggleMenu && (

      <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">

       
        {/* <select className='app__navbar-select overlay__language'>
          <option value="EN">English</option>
          <option value="ES">Spanish</option>
        </select> */}
        <MdOutlineRestaurantMenu fontSize={27} className="overlay__close" onClick={() => setToggleMenu(false)} />

        <div>
        <select style={{border:'1px solid #894e3f', borderRadius:'30px', outline:'0', background:'white', color: '#894e3f'}} className='overlay__language'>
          <option value="EN">English</option>
          <option value="ES">Spanish</option>
        </select>
        </div>

        <ul className="app__navbar-smallscreen_links">
          <li className="p__opensans2"><a href="/">Home</a></li>
          <li className="p__opensans2"><a href="/about">About</a></li>
          <li className="p__opensans2"><a href="/menu">Menu</a></li>
          <li className="p__opensans2"><a href="/gallery">Gallery</a></li>
          <li className="p__opensans2"><a href="#contact">Contact</a></li>
        </ul>

      </div>
      )}
   </div>
   
  </nav>
)};

export default Navbar;
